import { StatusBadge } from '../MetricsCards';

/** Execution list/drawer status — same visuals as prompts (icons + running white text). */
export function ExecutionStatusBadge({ status }: { status: string }) {
  return <StatusBadge status={status} />;
}
